import { Footer, FooterProps } from '~shared/ui/footer';
import { ProgressBar } from '~shared/ui/progress-bar';

type Props = {
  currentStepIndex: number;
  totalSteps: number;
  stepPercentage?: number;
  submitButtonText?: string;
} & Omit<FooterProps, 'submitButtonText'>;

export const FooterWithProgressBar = ({
  currentStepIndex,
  totalSteps,
  stepPercentage,
  isLoading,
  onSkip,
  extraContent,
  submitButtonText,
  onSubmit,
}: Props) => {
  const isLastStep = currentStepIndex + 1 === totalSteps;
  const defaultSubmitButtonText = isLastStep ? 'Submit' : 'Next';

  return (
    <Footer
      isLoading={isLoading}
      onSkip={onSkip}
      onSubmit={onSubmit}
      submitButtonText={
        submitButtonText ? submitButtonText : defaultSubmitButtonText
      }
      topContent={
        <ProgressBar
          currentStepIndex={currentStepIndex}
          totalSteps={totalSteps}
          stepPercentage={stepPercentage}
        />
      }
      extraContent={extraContent}
    />
  );
};
